var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 239.749 239.749",
    style: {
      enableBackground: "new 0 0 239.749 239.749"
    },
    xmlSpace: "preserve",
    height: "1em",
    width: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M5.081,26.555c-2.768,1.784-5.08,4.384-5.08,8.104v150.047c0,0-0.598,30.965,29.121,30.965h189.198 c6.005,0,14.762-1.686,18.047-5.45c1.876-2.154,3.383-4.901,3.383-8.18c0-3.334-1.556-6.391-3.47-8.893 c-3.263-4.264-11.955-6.619-17.96-6.636l-167.757-0.528c-6.01-0.022-15.072,0.761-18.52-2.094 c-1.653-1.365-2.921-3.612-2.921-7.267v-24.411c0-6.005,4.645-12.341,10.378-14.136l37.899-11.906 c5.733-1.8,14.212-0.25,18.939,3.459l43.235,33.923c4.727,3.709,12.102,3.378,16.475-0.745l74.058-69.761 c4.373-4.123,8.001-12.33,8.099-18.335l0.402-23.693c0.103-6.005-3.334-7.506-7.669-3.345l-73.998,70.942 c-4.335,4.161-11.754,4.618-16.567,1.023l-42.55-31.786c-4.814-3.595-13.309-4.895-18.982-2.91L39.706,98.682 c-5.668,1.991-10.291-1.267-10.312-7.277l-0.218-47.108c-0.027-6.005-1.991-14.832-6.103-18.031 C18.961,23.063,9.726,23.563,5.081,26.555z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.4febe558.svg";
export { ForwardRef as ReactComponent };